"use client";
import React from "react";
import { storyblokEditable } from "@storyblok/react";
import TextColumnSection from "@/library/sections/texts/TextColumnSection";

export default function TextColumnSectionBlock({ blok }) {
  return (
    <div {...storyblokEditable(blok)}>
      <TextColumnSection
        blok={blok}
        backgroundColor={blok.backgroundColor}
        columns={blok.columnBlocks || []}
        backgroundImage={blok.backgroundImage}
      />
    </div>
  );
}
